<template>
<div class="chapter">
<div class="inner_page">
<h3 class="chaptitle">Century Club, New York City, 2001</h3>
<p class="noindent">“That’s an odd reference,” I said. “O. Henry. ‘The Gift of the Magi.’ Are you religious?”</p>
<p class="indent">“Not then or now,” Danforth answered. “But we lived in a culturally coherent world, Clayton and I, a world of shared symbols and references. Old Testament. New Testament.”</p>
<p class="indent">“A coherence our current enemies now have in abundance,” I added coldly. “But which we have somewhat lost.”</p>
<p class="indent">Danforth shrugged. “True enough, but would you want it back if you got the Duke of Alva with it too?”</p>
<p class="indent">I had no idea who the Duke of Alva was but saw no need to demonstrate that lack of familiarity, and so I said, “Meaning what?”</p>
<p class="indent">“That it’s easy to become what you once abhorred,” Danforth answered.</p>
<p class="indent"><a id="page_30"></a>This struck me as rather windy, and probably a quote. I returned to the more relevant subject at hand. “So, Clayton had made his proposal,” I said. “What did you do then?”</p>
<p class="indent">“Despite the snow, I started walking uptown,” Danforth answered. “On the way, I thought about the young woman, about what she was willing to do. And I thought about myself. I even thought about O. Henry. I was still turning all that over in my mind when I got to the Plaza.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Pt1Ch7.vue?e999c318